import {
  ControlProps,
  RankedTester,
  rankWith,
  uiTypeIs,
} from '@jsonforms/core';
import { useJsonForms, withJsonFormsEnumProps } from '@jsonforms/react';
import get from 'lodash/get';
import React, { useEffect, useState } from 'react';
import { InputEnum } from '../spectrum-control/InputEnum';
import { SpectrumInputControl } from './SpectrumInputControl';

export const SpectrumStaticConditionalEnumControl = (props: ControlProps) => {
  const context = useJsonForms();
  const [fetchedOptions, setFetchedOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const dependentOn = props.uischema.options?.dependentOn;
  const dependencyKey = get(context?.core?.data, dependentOn);

  const allOptions = props.schema?.enum || [];

  useEffect(() => {
    setFetchedOptions(
      allOptions.filter((item) => item.parentValue === dependencyKey) || []
    );
  }, [dependencyKey]);

  return (
    <SpectrumInputControl
      {...props}
      options={fetchedOptions.map((item) => ({
        label: item.value,
        value: item.value,
      }))}
      input={InputEnum}
    />
  );
};

export const spectrumStaticConditionalEnumControlTester: RankedTester = rankWith(
  3,
  uiTypeIs('StaticConditionalPicker')
);

export default withJsonFormsEnumProps(SpectrumStaticConditionalEnumControl);
